import { EventBus } from '@/plugins/event-bus'
import ConfigurationExtendedApi from 'api-client/ConfigurationExtended'
import axios from 'axios'

const moduleState = {
  configurationExtended: null,
  komNumber: '',
}

const getters = {
  configurationExtended: (state) => state.configurationExtended,
  komNumber: (state) => state.komNumber,
}

const mutations = {
  setConfigurationExtended: (state, payload) => {
    state.configurationExtended = payload
    EventBus.$emit('configurationExtended/configurationExtended')
  },
  setKomNumber: (state, payload) => {
    state.komNumber = payload
  },
}

const actions = {
  getConfigurationExtended: ({ commit, dispatch }, payload) => {
    return ConfigurationExtendedApi.getConfigurationExtended(
      payload.configurationCode,
      payload.deliveryDate
    )
      .then((response) => {
        commit('setConfigurationExtended', response)
        commit('setKomNumber', '')
        return Promise.resolve(response)
      })
      .catch((e) => {
        if (axios.isCancel(e)) {
          return
        }
      })
  },
  getStockCarExtended: ({ commit, dispatch }, payload) => {
    return ConfigurationExtendedApi.getStockCarExtended(payload.stockCarId, payload.deliveryDate)
      .then((response) => {
        commit('setConfigurationExtended', response.Configuration)
        commit('setKomNumber', response.StockCarDetails.KomNumber?.Number)
        return Promise.resolve(response)
      })
      .catch((e) => {
        if (axios.isCancel(e)) {
          return
        }
      })
  },
  getNewStockExtended: ({ commit, dispatch }, payload) => {
    return ConfigurationExtendedApi.getNewStockExtended(
      payload.stockId,
      payload.deliveryDate,
      payload.extendedConfiguration
    )
      .then((response) => {
        commit('setConfigurationExtended', response.Configuration)
        commit('setKomNumber', response.CommissionNumber)
        return Promise.resolve(response)
      })
      .catch((e) => {
        if (axios.isCancel(e)) {
          return
        }
      })
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
